/* esm.sh - micromark-extension-gfm-autolink-literal@2.1.0 */
export * from "/*micromark-extension-gfm-autolink-literal@2.1.0/esnext/micromark-extension-gfm-autolink-literal.mjs";
